var map = {
	"./brand1.png": 4967,
	"./brand2.png": 4332,
	"./brand3.png": 3749,
	"./carousel1.jpg": 6476,
	"./carousel2.jpg": 8459,
	"./carousel3.jpg": 414,
	"./factory1.png": 1620,
	"./factory2.png": 3247,
	"./factory3.png": 9446,
	"./factory4.png": 9417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4331;